import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-three-dots-menu',
  templateUrl: './three-dots-menu.component.html',
  styleUrls: ['./three-dots-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

/**
 * Standard button component, use for any type of button
 *
 * @var isClicked used to indicate when the button is clicked =>
 * @var active = 'active' to set css class (color change) when @var isClicked = true
 * @var horizontal indicates if the dots are horizontal (true) or vertical (false)
 * @var alignLeft aligns three-dots left inside it's wrapper div (when true)
 * @var hover indicates if the css class (color change) on hover is applied
 * @var divStyle used to add any css classes on the wrapper div
 */
export class ThreeDotsMenuComponent implements OnChanges {
  @Input() isClicked = false;
  @Input() horizontal = false;
  @Input() alignLeft = false;
  @Input() disabled = false;
  @Input() hover = true;
  @Input() divStyle: string;
  active: 'active' | '';

  ngOnChanges(simpleChanges: SimpleChanges): void {
    if (simpleChanges.isClicked && !this.disabled) {
      this.active = this.hover && this.isClicked ? 'active' : '';
    }
  }
}
